import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { useUiColor } from "../../utils/UIContext";

type ColorProps = {
  $fgOnLight: string;
  $fg: string;
  $border: string;
  $borderHover: string;
  $bgSoft: string;
};

const StyledBasicColored = styled.button<ColorProps>`
  background: transparent none;
  color: ${({ $fgOnLight }) => $fgOnLight};
  box-shadow: 0 0 0 1px ${({ $border }) => $border} inset;
  font-weight: normal !important;

  &:hover,
  &:focus {
    background-color: transparent;
    color: ${({ $fgOnLight }) => $fgOnLight};
    box-shadow: 0 0 0 1px ${({ $borderHover }) => $borderHover} inset;
  }

  &:active {
    color: ${({ $fg }) => $fg};
    background-color: ${({ $bgSoft }) => $bgSoft};
    box-shadow:
      0 0 0 1px ${({ $borderHover }) => $borderHover} inset,
      0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function BasicColoredButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledBasicColored
      as={as}
      className={className}
      $fgOnLight={uiColor.fgOnLight}
      $fg={uiColor.fg}
      $border={uiColor.border}
      $borderHover={uiColor.borderHover || uiColor.border}
      $bgSoft={uiColor.bgSoft}
      {...props}
    />
  );
}
